import * as UI from "@accurx/design";
import { Ds } from "@accurx/design";
import { Pill } from "@accurx/inbox-design-library";
import styled from "styled-components";

export const StyledPopoverContent = styled(UI.PopoverContent)`
    &[data-state="open"] {
        border: 1px solid var(--ds-color-silver);
    }
`;

export const HiddenOverflowTooltipTrigger = styled(Ds.Tooltip.Trigger)`
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 90px;

    &:focus-within {
        box-shadow: 0 0 0 1px var(--ds-color-metal),
            0 0 0 3px var(--ds-color-white), 0 0 0 5px var(--ds-color-blue-100);
        border-radius: 50px;
    }
`;

export const StyledPillText = styled(Pill.Text)`
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledPillDropdown = styled(Pill.Dropdown)`
    position: relative;

    &:focus {
        box-shadow: none;
    }
`;
